import { Button } from "../../ui/button.tsx";

import { Separator } from "../../ui/separator.tsx";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "../../ui/dialog.tsx";

import { Trash } from "lucide-react";

import { useApi } from "../../../Api/useApi.ts";

import { useMutation } from "@tanstack/react-query";
import { useFormEditorContext } from "../../../Contexts/FormEditorContext.jsx";

type DeleteWebhookProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    webhookId?: string;
};

export const DeleteWebhook = ({
    open,
    onOpenChange,
    webhookId,
}: DeleteWebhookProps) => {
    const api = useApi();
    const { setFormSettings } = useFormEditorContext();
    const deleteWebhookMutation = useMutation({
        mutationFn: (webhookId: string) =>
            api.integrations.deleteWebhook(webhookId),
        onSuccess: () => {
            setFormSettings((prev: any) => ({
                ...prev,
                integrations: {
                    ...prev.integrations,
                    webhook_integration:
                        prev?.integrations?.webhook_integration?.filter(
                            (webhook: any) => webhook?.id !== webhookId,
                        ),
                },
            }));
            onOpenChange(false);
        },
        onError: (error) => {
            console.error("Error details:", error);
        },
    });

    const handleDeleteWebhook = () => {
        if (webhookId) {
            deleteWebhookMutation.mutate(webhookId);
        }
    };
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="top-[50%] sm:w-[380px] p-0">
                <DialogHeader className="px-3 pt-3">
                    <DialogTitle className="flex flex-row items-center gap-2 text-sm">
                        <Trash className="w-3 h-3" />
                        Delete Webhook
                    </DialogTitle>
                </DialogHeader>
                <Separator />
                <p className="text-[#191B33] text-sm px-3">
                    If you delete this webhook, we can't get it back for you
                    after. Buildform submissions won't get delivered to your
                    endpoint any more.
                </p>
                <Separator />
                <DialogFooter className="px-3 pb-3">
                    <Button
                        variant="outline"
                        className="h-[36px] text-sm"
                        onClick={() => onOpenChange(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="destructive"
                        className="bg-[#F44336] h-[36px] text-sm"
                        onClick={handleDeleteWebhook}
                    >
                        Delete this Webhook
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
